import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import React, { useMemo, useRef, useState, useEffect } from 'react';
import { BASE_URL } from '../App/Configs/AppConfigs';

let searchData = []

function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = useRef(0);
  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(newOptions);
        setFetching(false);
        searchData = newOptions
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  );
}

// Usage of DebounceSelect
async function fetchSupplierList(search) {

  return fetch(BASE_URL + '/master/masters.MstSupplier/list' + "?pageSize=10&page=1&search=" + search, { headers: { Authorization: JSON.parse(localStorage.getItem(`${process.env.REACT_APP_TOKEN_PREFIX}-auth-token`)), } })
    .then((response) => response.json())
    .then((body) =>
      body.results.map((supplier) => ({
        label: `${supplier.display_name}` + " (" + supplier.code + ")",
        value: supplier.display_name + " (" + supplier.code + ")",
        key: supplier.code
      })),
    );
}

const SupplierSearchBox = (props) => {
  let initialValue = '[]'
  if (props.initialValues) {
    initialValue = props.initialValues[props.decorator]
  }
  const [value, setValue] = useState(JSON.parse(initialValue));
  
  useEffect(() => {
    try {
      if (props.isFormList) {
        let formListData = props.formRef.current.getFieldValue(props.formListDecorator)
        initialValue = formListData[props.decorator[0]][props.decorator[1]]
      } else {
        initialValue = props.formRef.current.getFieldValue(props.decorator)
      }
      setValue(JSON.parse(initialValue))
    } catch (e) { }
  }, [props.formRef.current ? props.formRef.current.getFieldValue(props.decorator) : null]);
  
  return (
    <DebounceSelect
      value={value}
      placeholder={props.placeholder}
      disabled={props.disabled}
      mode={props.mode}
      fetchOptions={fetchSupplierList}
      onSelect={(newValue) => {
        if (props.isFormList && props.mode != 'multiple') {
          try {
            let formListData = props.formRef.current.getFieldValue(props.formListDecorator)
            formListData[props.decorator[0]][props.decorator[1]] = JSON.stringify(newValue)
            props.formRef.current.setFieldValue(props.formListDecorator, formListData)
          } catch (c) { }
        }
        else if (props.mode != 'multiple') {
          props.formRef.current.setFieldValue(props.decorator, JSON.stringify(newValue))
        }
        if(props.hasOwnProperty('callback')){
          props.callback(newValue)
        }
      }}

      onChange={(newValue) => {
        if (props.mode == 'multiple') {
          if (newValue.length == 0) {
            props.formRef.current.resetFields([props.decorator])
          } else {
            props.formRef.current.setFieldValue(props.decorator, JSON.stringify(newValue))
          }
        }
        if (newValue.value === "") {
          if (props.isFormList) {
            try {
              let formListData = props.formRef.current.getFieldValue(props.formListDecorator)
              formListData[props.decorator[0]][props.decorator[1]] = null
              props.formRef.current.setFieldValue(props.formListDecorator, formListData)
            } catch (c) { }
          }
        }
        setValue(newValue);
      }}
      style={{
        width: '100%',
      }}
    />
  );
};
export default SupplierSearchBox;